"use client";

import { ChevronDown } from "lucide-react";
import { useState } from "react";

export function PricingFaq({ items }: { items: ReadonlyArray<{ question: string; answer: string }> }) {
  const [open, setOpen] = useState(0);

  return (
    <div className="mt-4 flex flex-col gap-2">
      {items.map((item, index) => {
        const expanded = open === index;
        const panelId = `pricing-faq-${index}`;
        return (
          <div key={item.question} className="rounded-[10px] border border-[var(--m-line)] bg-white">
            <button
              type="button"
              className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left text-[15px] font-medium text-[var(--m-ink)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--m-accent)]"
              aria-expanded={expanded}
              aria-controls={panelId}
              onClick={() => setOpen(expanded ? -1 : index)}
            >
              <span>{item.question}</span>
              <ChevronDown className={`size-4 shrink-0 text-[#8aa0b8] transition-transform ${expanded ? "rotate-180" : ""}`} aria-hidden="true" />
            </button>
            {expanded ? (
              <p id={panelId} className="px-4 pb-4 text-sm leading-6 text-[var(--m-muted)]">
                {item.answer}
              </p>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
